import { toZonedTime } from "date-fns-tz";

export function formatDate(dateStr) {
  const dateObj = new Date(dateStr);
  return dateObj.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  });
}
export function formatDatev2(dateStr) {
  if (!dateStr || isNaN(new Date(dateStr).getTime())) {
    return '';
  }

  const dateObj = new Date(dateStr);
  const day = dateObj.getDate();
  const month = dateObj.toLocaleString('en-US', { month: 'short' });
  const year = dateObj.getFullYear();

  return `${day} ${month} ${year}`;
}

  export function formatCurrentDate() {
    const options = { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
    };
    const date = new Date();
    return date.toLocaleDateString('en-US', options);
}
export function formatDateToYMD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0'); // Pad day with leading 0 if needed
  return `${year}-${month}-${day}`;
}

//Thursday, September 5, 2024
export const decodeTimeToISO = (minutes) => {
  // Get hours and minutes from total minutes
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  // Set seconds and milliseconds to 0
  const seconds = 0;
  const milliseconds = 0;

  // Format hours and minutes to always have two digits
  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = mins.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');
  const formattedMilliseconds = milliseconds.toString().padStart(3, '0');

  // Return the formatted time in the "HH:MM:SS.mmmZ" format
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}.${formattedMilliseconds}Z`;
};
export function currentformatedDate() {
  const today = new Date();
    
    // Options for formatting the date and time
    const options = { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric', 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit', 
        hour12: false, 
        timeZone: 'Asia/Kolkata' 
    };

    // Create the formatted date string
    const dateString = today.toLocaleString('en-US', options).replace(',', '');
    
    // Get the timezone offset
    const timezoneOffset = today.getTimezoneOffset();
    const hoursOffset = String(Math.abs(Math.floor(timezoneOffset / 60))).padStart(2, '0');
    const minutesOffset = String(Math.abs(timezoneOffset % 60)).padStart(2, '0');
    const gmtOffset = `GMT${timezoneOffset <= 0 ? '+' : '-'}${hoursOffset}${minutesOffset}`;

    // Fixed timezone name for India Standard Time
    const timezoneName = 'India Standard Time';

    return `${dateString} ${gmtOffset} (${timezoneName})`;
}

//input 2024-10-29T08:40:16
//output Mon, Oct 14, 2024"
export function formatTimestampToDDMMDtYYYY(timestamp) {
  // Try to create a new Date object from the timestamp
  const date = new Date(timestamp);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return ''; // Return an empty string if the timestamp is invalid
  }

  // Define an options object for date formatting
  const options = { weekday: 'short', month: 'short', day: '2-digit', year: 'numeric' };

  // Format the date to the desired format
  return date.toLocaleDateString('en-US', options);
}


export function formatappdate(inputDate) {
  const date = new Date(inputDate);
  
  // Check if the date is valid
  if (isNaN(date.getTime())) {
      return new Date().toLocaleDateString('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
      });
  }

  return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
  });
}

// // Example usage
// console.log(formatDate("2025-02-09"));  // Sunday, February 9, 2025
// console.log(formatDate("invalid-date"));  // Current date in the same format
export function convertToddmmyyy(dateString) {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return ''; // Return empty string for invalid date
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  
  return `${day}/${month}/${year}`;
}

 // Output: "28/03/2025"
 // Output: ""
export const formatChipDate2 = (date) => {
  // Check if the input is a valid Date
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return false; // Return false for invalid dates
  }

  // Convert the date to the desired timezone
  const timezone = 'Asia/Kolkata'; // Adjust the timezone as needed
  const zonedDate = toZonedTime(date, timezone);
  const today = toZonedTime(new Date(), timezone); // Get today's date in the same timezone




  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const dayOfMonth = zonedDate.getDate();
  const month = months[zonedDate.getMonth()];
  const year = zonedDate.getFullYear();

  // Format the date as "2 Sep, 2024"
  return `${dayOfMonth} ${month.slice(0, 3)}, ${year}`; // Shortened month name
};

export function formatAppointmentTime(timeStr, fallbackDate) {
  if (timeStr && typeof timeStr === 'string') {
    const parts = timeStr.trim().split(':');
    if (parts.length >= 2) {
      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);
      if (!isNaN(hours) && !isNaN(minutes)) {
        const period = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
        const formattedMinutes = minutes.toString().padStart(2, '0');
        return `${formattedHours}:${formattedMinutes} ${period}`;
      }
    }
  }
  if (fallbackDate) {
    const d = new Date(fallbackDate);
    if (!isNaN(d.getTime())) {
      return d.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      });
    }
  }
  return '';
}